import { OptionCard } from "./OptionCard";

const BUDGETS = ["Under $1,000", "$1,000 - $5,000", "$5,000 - $15,000", "$15,000 - $30,000", "$30,000+", "Not sure yet"];

export const BudgetStep = ({ value, onChange }) => (
  <div className="grid gap-3" data-testid="budget-input">
    {BUDGETS.map((b, i) => (
      <OptionCard key={b} title={b.replace(" - ", " – ")} selected={value === b} compact
        onClick={() => onChange(value === b ? null : b)} testId={`budget-option-${i}`} />
    ))}
  </div>
);
